// src/components/navigation/TopSegmentedNav.jsx
import React from "react";
import { NavLink, useLocation } from "react-router-dom";

/**
 * Two-tab segmented control pinned under the NavBar.
 * - Visible only on /home and /home/trends
 * - Left: Activity (/home)
 * - Right: Trends (/home/trends)
 * - Matches NavBar container background
 * - Selected tab shows a bottom border in primary
 */
export default function TopSegmentedNav() {
  const { pathname } = useLocation();

  // Show only on /home or /home/trends routes
  const showNav = pathname === "/home" || pathname.startsWith("/home/");
  if (!showNav) return null;

  const isTrends = pathname.startsWith("/home/trends");
  const isActivity = !isTrends; // covers /home and nested /home/... except /home/trends

  const baseBtn =
    "flex-1 text-center py-3 text-sm md:text-base font-medium transition-colors";
  const selected = "border-b-2 border-primary text-primary";
  const idle =
    "border-b-2 border-transparent text-greyscale-1 hover:text-primary/70";

  return (
    <div
      role="tablist"
      aria-label="Primary sections"
      className="w-full sticky top-0 z-30 bg-container"
    >
      <div className="mx-auto max-w-2xl">
        <div className="grid grid-cols-2">
          <NavLink
            to="/home"
            role="tab"
            aria-selected={isActivity}
            aria-current={isActivity ? "page" : undefined}
            className={`${baseBtn} ${isActivity ? selected : idle}`}
          >
            Activity
          </NavLink>
          <NavLink
            to="/home/trends"
            role="tab"
            aria-selected={isTrends}
            aria-current={isTrends ? "page" : undefined}
            className={`${baseBtn} ${isTrends ? selected : idle}`}
          >
            Trends
          </NavLink>
        </div>
      </div>
    </div>
  );
}
